import React, { Fragment, useState, useCallback } from 'react';
import { translate } from '../Services/translation';
import { useSelector } from 'react-redux';
import constants from '../constants';

const CookieBar = ({
    cookiebarVisibleValue,
    showButton,
    functionalValue = false,
    analyticsValue = false,
    marketingValue = false,
    personalizationValue = false,
}) => {
    const {
        settingsVisible,
        functional,
        analytics,
        marketing,
        personalization,
        cookiebarVisible,
    } = useSelector((state) => state.cookieBar);

    const [currentSettingsVisible, setSettingsVisible] = useState(
        settingsVisible || false
    );
    const toggleSettings = useCallback(
        (show) => {
            setSettingsVisible(show);
        },
        [currentSettingsVisible]
    );

    const [currentFunctional, setFunctional] = useState(
        functional || functionalValue
    );
    const toggleFunctional = useCallback(() => {
        setFunctional(!currentFunctional);
    }, [currentFunctional]);

    const [currentAnalytics, setAnalytics] = useState(
        analytics || analyticsValue
    );
    const toggleAnalytics = useCallback(() => {
        setAnalytics(!currentAnalytics);
    }, [currentAnalytics]);

    const [currentMarketing, setMarketing] = useState(
        marketing || marketingValue
    );
    const toggleMarketing = useCallback(() => {
        setMarketing(!currentMarketing);
    }, [currentMarketing]);

    const [currentPersonalization, setPersonalization] = useState(
        personalization || personalizationValue
    );
    const togglePersonalization = useCallback(() => {
        setPersonalization(!currentPersonalization);
    }, [currentPersonalization]);

    const [currentCookiebarVisible, setCookiebarVisible] = useState(
        cookiebarVisible || cookiebarVisibleValue
    );
    const toggleCookieBar = useCallback(() => {
        setCookiebarVisible(!currentCookiebarVisible);
    }, [currentCookiebarVisible]);

    const acceptAllCookies = () => {
        toggleCookieBar();
        updateCookies(true, true, true, true);
    }
    const rejectAllCookies = () => {
        toggleCookieBar();
        updateCookies(false, false, false, false);
    }

    const acceptCookies = () => {
        if (currentCookiebarVisible) {
            toggleCookieBar();
        }
        toggleSettings();
        updateCookies(currentFunctional, currentAnalytics, currentMarketing, currentPersonalization);
    }

    const updateCookies = (functional, analytics, marketing, personalization) => {
        var now = new Date();
        now.setTime(now.getTime() + 3600 * 1000 * 24 * 365);
        var cookieExpires = now.toUTCString();

        document.cookie = "cookie_consent3=|" +
            (functional ? "functional|" : "") +
            (analytics ? "analytics|" : "") +
            (marketing ? "marketing|" : "") +
            (personalization ? "personalization|" : "") +
            ";expires=" + cookieExpires + ";path=/";

        gtag('consent', 'update', {
            'ad_storage': (marketing ? 'granted' : 'denied'),
            'analytics_storage': (analytics ? 'granted' : 'denied'),
            'ad_personalization': (personalization ? 'granted' : 'denied'),
            'ad_user_data': (personalization ? 'granted' : 'denied'),
            'personalization_storage': (personalization ? 'granted' : 'denied'),
            'functionality_storage': (functional ? 'granted' : 'denied')
        });

        if (analytics && window.hasOwnProperty('cevoid')) {
            window.cevoid.userCanBeTracked();
        }
    }

    const acceptCookiesWithDelay = () => {
        setMarketing(true);
        setAnalytics(true);
        setFunctional(true);
        setPersonalization(true);
        updateCookies(true, true, true, true);
        setTimeout(() => {
            if (currentCookiebarVisible) {
                toggleCookieBar();
            }
            toggleSettings();
        }, 1000);
    }

    return (
        <Fragment>
            {showButton &&
                <button className="cookie-bar-settings__accept-settings-btn all" onClick={() => toggleSettings(true)} aria-label={translate(`common.cookie.change`)}>{translate(`common.cookie.change`)}</button>
            }
            {currentCookiebarVisible &&
                <div className="cookie-bar">
                    <div className="cookie-bar__container row">
                        <div className="cookie-bar__content">{translate(`common.cookie.information1`) + ' '}<a className="cookie-bar-policy-link" href={constants.cookieTermsPageUrl}>{translate(`common.cookie.text`)}</a>{' ' + translate(`common.cookie.information2`)}<a className="cookie-bar-policy-link" href={constants.policyTermsPageUrl}>{translate(`common.cookie.privacy.policy`)}</a>.</div>
                        <div className="cookie-bar__button-container">
                            <button className="cookie-bar__accept-btn" onClick={() => acceptAllCookies()} aria-label={translate(`common.cookie.accept`)}>{translate(`common.cookie.accept`)}</button>
                            <button className="cookie-bar__accept-btn" onClick={() => rejectAllCookies()} aria-label={translate(`common.cookie.reject`)}>{translate(`common.cookie.reject`)}</button>
                            <button className="cookie-bar__settings-btn" onClick={() => toggleSettings(true)} aria-label={translate(`common.cookie.settings`)}>{translate(`common.cookie.settings`)}</button>
                        </div>
                    </div>
                </div>
            }
            {currentSettingsVisible &&
                <div className="cookie-bar-settings">
                    <div className="cookie-bar-settings__wrapper row">
                        <div className="small-12 columns">
                            <div className="cookie-bar-settings__header">
                                <h2 className="text--center">{translate(`common.cookie.header`)}</h2>
                            </div>
                            <div className="cookie-bar-settings__info">{translate(`common.cookie.settings.info`)} <a className="cookie-bar-policy-link" href={constants.cookieTermsPageUrl}>{translate(`common.cookie.settings.readmore`)}</a></div>
                            <div className="cookie-bar-settings__setting">
                                <div>{translate(`common.cookie.necessary`)}</div>
                                <div className="cookie-bar-settings__setting__status-container">{translate(`common.cookie.alwaysactive`)}</div>
                            </div>
                            <div className="cookie-bar-settings__setting">
                                <div>{translate(`common.cookie.functional`)}</div>
                                <div className="cookie-bar-settings__setting__status-container">
                                    <span className="cookie-bar-settings__status">{translate('common.cookie.' + (currentFunctional ? "active" : "disabled"))}</span>
                                    <label className="cookie-bar-settings__switch">
                                        <input type="checkbox" checked={currentFunctional} name="functional" onChange={() => toggleFunctional()} />
                                        <span className="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <div className="cookie-bar-settings__setting">
                                <div>{translate(`common.cookie.analysis`)}</div>
                                <div className="cookie-bar-settings__setting__status-container">
                                    <span className="cookie-bar-settings__status">{translate('common.cookie.' + (currentAnalytics ? "active" : "disabled"))}</span>
                                    <label className="cookie-bar-settings__switch">
                                        <input type="checkbox" checked={currentAnalytics} name="analytics" onChange={() => toggleAnalytics()} />
                                        <span className="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <div className="cookie-bar-settings__setting">
                                <div>{translate(`common.cookie.marketing`)}</div>
                                <div className="cookie-bar-settings__setting__status-container">
                                    <span className="cookie-bar-settings__status">{translate('common.cookie.' + (currentMarketing ? "active" : "disabled"))}</span>
                                    <label className="cookie-bar-settings__switch">
                                        <input type="checkbox" checked={currentMarketing} name="marketing" onChange={() => toggleMarketing()} />
                                        <span className="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <div className="cookie-bar-settings__setting">
                                <div>{translate(`code.cookie.personalization`)}</div>
                                <div className="cookie-bar-settings__setting__status-container">
                                    <span className="cookie-bar-settings__status">{translate('common.cookie.' + (currentPersonalization ? "active" : "disabled"))}</span>
                                    <label className="cookie-bar-settings__switch">
                                        <input type="checkbox" checked={currentPersonalization} name="personalization" onChange={() => togglePersonalization()} />
                                        <span className="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <div className="row">
                                <div className="small-12 medium-6 columns cookie-bar-settings__button-container">
                                    <button className="cookie-bar-settings__accept-settings-btn" onClick={() => acceptCookies()}>{translate(`common.cookie.settings.acceptchoices`)}</button>
                                </div>
                                <div className="small-12 medium-6 columns cookie-bar-settings__button-container">
                                    <button className="cookie-bar-settings__accept-settings-btn all" onClick={() => acceptCookiesWithDelay()}>{translate(`common.cookie.settings.acceptall`)}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </Fragment>
    );
};

export default CookieBar;